'use client';

import { c as _c } from "react/compiler-runtime";
import GalleryContent from '@/ui/segments/gallery/content';
import HeroGallery from '@/ui/segments/gallery/hero';
import Menu from '@/ui/segments/landing/layout/menu/menu';
import { EnumSection } from '@/ui/segments/landing/sections/sections';
import { useScrollHasStarted } from '@/utils/scroll-has-started';
import type { GalleryContentProps } from '@/services/sanity';
import styles from '@/ui/segments/landing/landing-page.module.css';
type GalleryPageProps = {
  galleryContent: GalleryContentProps[];
};
export default function GalleryPage(t0) {
  const $ = _c(8);
  const {
    galleryContent
  } = t0;
  const scrollHasStarted = useScrollHasStarted();
  let t1;
  if ($[0] !== scrollHasStarted) {
    t1 = <Menu scrollHasStarted={scrollHasStarted} section={EnumSection.Gallery} />;
    $[0] = scrollHasStarted;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeroGallery videoURL="https://player.vimeo.com/progressive_redirect/playback/1129107045/rendition/1080p/file.mp4?loc=external&log_user=0&signature=24971da0f0dba7530737456770428772dfed7fd99b400c3f31e41638bf741059" posterURL="/video/thumb.jpg" posterWidth={1920} posterHeight={1080} title="Gallery" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== galleryContent) {
    t3 = <GalleryContent galleryContent={galleryContent} />;
    $[3] = galleryContent;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className={styles.landingPage}>{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}